<template>
    <BaseLabel :class="`palette--${buurt.slug}`" :label="buurt?.title" :marker />
</template>

<script setup lang="ts">
const props = defineProps<{
    buurt: {
        title: string,
        slug: string
    }
}>();

const { buurt } = toRefs(props);

const marker = computed(() => {
    switch (buurt.value?.slug) {
    case 'centrum':
        return '7';

    case 'nieuw-west':
        return '8';

    case 'noord':
        return '4';

    case 'oost':
        return '5';

    case 'west':
        return '6';

    case 'zuid':
        return '4';

    case 'zuidoost':
        return '10';

    default:
        return undefined;
    }
});
</script>
